import { passwordStrength } from "@/lib/passwordStrength";
import { cn } from "@/lib/utils";

type Props = {
  password: string;
  className?: string;
};

/**
 * Barra visual de fortaleza (4 segmentos) + label + hints.
 * Usar debajo del input de password en SignUp / Reset.
 */
export function PasswordStrengthBar({ password, className }: Props) {
  if (!password) return null;
  const s = passwordStrength(password);

  return (
    <div className={cn("space-y-1", className)}>
      <div className="flex items-center gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={cn(
              "h-1 flex-1 rounded",
              i < s.score ? s.colorClass : "bg-muted",
            )}
          />
        ))}
        <span className="ml-2 min-w-[70px] text-right text-xs font-bold text-muted-foreground">
          {s.label}
        </span>
      </div>
      {s.feedback.length > 0 ? (
        <p className="text-xs text-muted-foreground">
          {s.feedback.slice(0, 2).join(" · ")}
        </p>
      ) : null}
    </div>
  );
}
